import { useBoringVaultV1 } from 'boring-vault-ui';
import { BoringQueueStatus } from 'boring-vault-ui/types';
import { useConnection } from 'modules/auth';
import { getErrorMessage } from 'modules/common/utils/getErrorMessage';
import { useVaultProvider } from 'modules/dashboard/components/Deposit/VaultContextProvider/hooks/useVaultProvider';
import { showNotification } from 'modules/notifications';
import { useEffect, useMemo, useState } from 'react';

export function usePendingWithdrawal() {
  const { address, chainId } = useConnection();
  const [isLoading, setLoading] = useState(false);
  const { withdrawQueueStatuses, boringQueueStatuses } = useBoringVaultV1();
  const [statuses, setStatuses] = useState<Record<string, any>>({});
  const { provider } = useVaultProvider();

  const pendingWithdrawal = useMemo(() => {
    if (!statuses || !address) return;

    return statuses[address]?.[0];
  }, [statuses, address]);

  useEffect(() => {
    const fetchStatuses = async () => {
      if (!provider || !address) return;
      setLoading(true);
      try {
        const signer = await provider.getSigner();
        const fetchedStatuses: BoringQueueStatus[] = await boringQueueStatuses(
          signer!,
        );

        setLoading(false);
        setStatuses(state => ({ ...state, [address]: fetchedStatuses }));
      } catch (err) {
        showNotification({
          message: getErrorMessage(err),
          variant: 'error',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchStatuses();
  }, [withdrawQueueStatuses, provider, address, chainId]);

  const clearStatuses = () => {
    setStatuses({});
  };

  return { data: pendingWithdrawal, clearStatuses, isLoading };
}
